"use strict";
import { screens } from "tailwindcss/defaultTheme";
import { initializeCommentsDropdown } from "../../decidim/comments/comments_dropdown";
const addCommentMobile = function(addCommentCard) {
  const smBreakpoint = parseInt(screens.sm.replace("px", ""), 10);
  if (window.matchMedia(`(max-width: ${smBreakpoint}px)`).matches) {
    addCommentCard.classList.remove("hidden");
    addCommentCard.classList.add("fullscreen");
  }
};
const closeAddComment = function(addCommentCard) {
  addCommentCard.classList.add("hidden");
  addCommentCard.classList.remove("fullscreen");
};
document.addEventListener("DOMContentLoaded", () => {
  const addCommentCard = document.getElementById("add-comment-anchor");
  if (addCommentCard) {
    document.querySelectorAll(".add-comment-mobile").forEach((addButtonMobile) => {
      addButtonMobile.addEventListener("click", () => {
        addCommentMobile(addCommentCard);
      });
    });
  }
  const closeButton = document.querySelector(
    "#add-comment-anchor .close-add-comment-fullscreen"
  );
  if (closeButton) {
    closeButton.addEventListener(
      "click",
      () => closeAddComment(addCommentCard)
    );
  }
  initializeCommentsDropdown(document);
});
